var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: _vm.title,
        visible: _vm.visible,
        "close-on-click-modal": false,
        width: "800px"
      },
      on: { close: _vm.handleClose }
    },
    [
      _c(
        "div",
        [
          _c(
            "el-row",
            [
              _c("el-col", { attrs: { span: 6 } }, [_vm._v("选择照片")]),
              _c(
                "el-col",
                { attrs: { span: 18 } },
                [
                  _c(
                    "el-form",
                    [
                      _c(
                        "el-upload",
                        {
                          ref: "upload",
                          class: [
                            "avatar-uploader",
                            _vm.showAdd ? "" : "hide-upload"
                          ],
                          attrs: {
                            action:
                              _vm.action +
                              "?warehouseInUuid=" +
                              _vm.warehouseInUuid,
                            "on-success": _vm.handleSuccess,
                            "on-error": _vm.handleError,
                            "on-change": _vm.handleChange,
                            "on-remove": _vm.handleRemove,
                            "before-upload": _vm.handleBeforeUpload,
                            "on-exceed": _vm.handleExceed,
                            "file-list": _vm.fileList,
                            "auto-upload": false,
                            headers: _vm.headers,
                            "list-type": "picture-card",
                            multiple: true,
                            "on-preview": _vm.handlePictureCardPreview,
                            limit: 6,
                            accept: ".jpeg,.gif,.png,.bmp,.tiff",
                            name: "file"
                          }
                        },
                        [
                          _c("i", {
                            staticClass: "el-icon-plus avatar-uploader-icon"
                          }),
                          _c(
                            "div",
                            {
                              staticClass: "el-upload__tip",
                              attrs: { slot: "tip" },
                              slot: "tip"
                            },
                            [
                              _vm._v(
                                "文件大小不可超过20M，支持JPG,GIF,BMP,PNG,TIFF格式"
                              )
                            ]
                          )
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            {
              staticStyle: { "margin-top": "15px" },
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-col",
                { attrs: { span: 18, offset: 6 } },
                [
                  _c("el-form", [
                    _c(
                      "span",
                      [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "primary" },
                            on: { click: _vm.submitUpload }
                          },
                          [_vm._v("开始上传")]
                        ),
                        _c("el-button", { on: { click: _vm.handleClose } }, [
                          _vm._v("取 消")
                        ])
                      ],
                      1
                    )
                  ])
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          staticClass: "pic-preview",
          attrs: { visible: _vm.dialogVisible, "append-to-body": "" },
          on: {
            "update:visible": function($event) {
              _vm.dialogVisible = $event
            }
          }
        },
        [
          _c("img", {
            attrs: { width: "100%", src: _vm.dialogImageUrl, alt: "" }
          })
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }